import { useQueryClient } from '@tanstack/react-query';

import type { CommunityScheduledPost } from '~/interfaces/community';

import { type ActionResponse, useCommunityActionBase } from './useCommunityActionBase';
import { SCHEDULED_POSTS_QUERY_KEY } from './useCommunityScheduledPosts';

// A refused takeover reloads the queue too: another admin may have taken the post over, or its author was unbanned.
const useTakeOverCommunityScheduledPostMutation = () => {
  const queryClient = useQueryClient();

  return useCommunityActionBase<string, unknown, ActionResponse & { scheduled_post: CommunityScheduledPost }>({
    buildRequest: (scheduledPostId) => ({
      path: '/take_over_community_scheduled_post',
      fields: { scheduled_post_id: scheduledPostId },
    }),
    // Not awaited, so the post opens without waiting for the queue to reload.
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: SCHEDULED_POSTS_QUERY_KEY });
    },
  });
};

export default useTakeOverCommunityScheduledPostMutation;
